import { StoreState } from '@/core/models/store.interface';
import { Channel } from 'laravel-echo';
import { Module } from 'vuex';

export interface webSocket {
   userChannel?: Channel;
}

const WebSocketStore: Module<webSocket, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {
      SET_USER_CHANNEL(state, channel?: Channel) {
         state.userChannel = channel;
      },
   },
   actions: {},
};

export default WebSocketStore;
